import { render, staticRenderFns } from "./reginImageCheckedItem.vue?vue&type=template&id=39ca4f16&scoped=true&"
import script from "./reginImageCheckedItem.vue?vue&type=script&lang=js&"
export * from "./reginImageCheckedItem.vue?vue&type=script&lang=js&"
import style0 from "./reginImageCheckedItem.vue?vue&type=style&index=0&id=39ca4f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ca4f16",
  null
  
)

export default component.exports